/** Scroll layout for Tasks page tables (aligned with Contacts list pattern) */

export const taskTableScrollbarSx = {
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 4,
    backgroundColor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(255,255,255,0.28)" : "rgba(0,0,0,0.28)",
    "&:hover": {
      backgroundColor: (theme) =>
        theme.palette.mode === "dark" ? "rgba(255,255,255,0.38)" : "rgba(0,0,0,0.38)",
    },
  },
};

/** Main Tasks tab scroll for Owner / ViewAll (tables grow; page scrolls) */
export const taskMainPageScrollSx = {
  overflow: "auto",
  overflowX: "hidden",
  ...taskTableScrollbarSx,
};

/** Paper wrapper that fills a flex parent and keeps footer visible (member / ViewAssigned) */
export const taskTableBoundedPaperSx = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

/** Scrollable table body inside bounded Paper (member view only) */
export const taskTableBodyScrollSx = {
  flex: 1,
  minHeight: 0,
  height: 0,
  width: "100%",
  boxSizing: "border-box",
  overflowX: "auto",
  overflowY: "auto",
  ...taskTableScrollbarSx,
};

export const taskTableFooterShrinkSx = {
  flexShrink: 0,
};

/** Natural-height table (Owner / ViewAll) — no inner scroll; main container scrolls */
export const taskTableNaturalPaperSx = {
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
};
